<ng-container *ngIf="showStaticForPrototype">
    <nav class="paging">
        <ul class="reset">
            <li><button class="pagerprev disabled"></button></li>
            <li><a href="">1</a></li>
            <li><a href="">2</a></li>
            <li><a href="">3</a></li>
            <li><a href="">4</a></li>
            <li><button class="pagernext"></button></li>
        </ul>
    </nav>
</ng-container>

<ng-container *ngIf="!showStaticForPrototype">
    <pagination-template #p="paginationApi" [id]="config.id" (pageChange)="onPageChange($event)">
        <ng-container *ngIf="p.pages.length > 1">
            <div class="custom-pagination">
                <div class="pagination-previous" [class.disabled]="p.isFirstPage()">
                    <span (click)="!p.isFirstPage() ? p.previous() : false"><</span>
                </div>
                <div class="page-number" *ngFor="let page of p.pages" [class.current]="p.getCurrent() === page.value">
                    <span (click)="p.setCurrent(page.value)" *ngIf="p.getCurrent() !== page.value">{{ page.label }}</span>
                    <div *ngIf="p.getCurrent() === page.value">
                        <span>{{ page.label }}</span>
                    </div>
                </div>
                <div class="pagination-next" [class.disabled]="p.isLastPage()">
                    <span (click)="!p.isLastPage() ? p.next() : false">></span>
                </div>
            </div></ng-container
        >
    </pagination-template>
</ng-container>
